export default [
  {
    name: "piaggioModel",
    type: "gltfLoader",
    path: "/models/piaggio-kiosk.glb",
  },

  {
    name: "firstTexture",
    type: "textureLoader",
    path: "/textures/first_baked_yellow.webp",
  },

  {
    name: "secondTexture",
    type: "textureLoader",
    path: "/textures/second_baked.webp",
  },

  {
    name: "thirdTexture",
    type: "textureLoader",
    path: "/textures/third_baked.webp",
  },
  {
    name: "floorTexture",
    type: "textureLoader",
    path: "/textures/floor_baked_yellow.webp",
  },

  {
    name: "realTextures",
    type: "textureLoader",
    path: "/textures/real_textures.webp",
  },

  {
    name: "kioskTexture",
    type: "textureLoader",
    path: "/textures/kiosk_baked.webp",
  },

  {
    name: "perlinTexture",
    type: "textureLoader",
    path: "/textures/perlin.png",
  },

  {
    name: "bannerTexture",
    type: "textureLoader",
    path: "/textures/kiosk_banner.webp",
  },

  {
    name: "partnersTexture",
    type: "textureLoader",
    path: "/textures/partners.webp",
  },

  {
    name: "documentsTexture",
    type: "textureLoader",
    path: "/textures/documents.png",
  },

  //? TEXTURES
];
